import { useFlags } from 'launchdarkly-react-client-sdk';

import { canAccessNavItem } from 'scopes/nav';
import { useScopes } from './useScopes';

export function useCanAccessNavItem() {
  const { scopeDetails } = useScopes();
  const featureFlags = useFlags();
  return navKey => canAccessNavItem({ navKey, scopeDetails, featureFlags });
}
